module.exports = __webpack_public_path__ + "static/fonts/iconfont.ae060f85.eot";